import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { postApi } from '../../../Services/apiService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({ email: '' });
    const [loader, setLoader] = useState(false);
    const [emailSent, setEmailSent] = useState(false);

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        setErrors({ email: '' });

        const trimmedEmail = email.trim();
        if (!trimmedEmail) {
            setErrors({ email: 'Email is required.' });
            return;
        }
        if (!/\S+@\S+\.\S+/.test(trimmedEmail)) {
            setErrors({ email: 'Please enter a valid email address.' });
            return;
        }

        setLoader(true);
        try {
            const response = await postApi('/api/v1/forgot-password', { email: trimmedEmail }, {}, false);

            if (response?.statusCode === 200 || response?.statusCode === 201) {
                setEmailSent(true);
                toast.success(response?.message || 'Password reset link sent to your email.');
            } else {
                const errorMessage = response?.message || response?.error || 'Failed to send reset link. Please try again.';
                if (response?.errors?.email) {
                    setErrors({ email: response.errors.email });
                } else {
                    toast.error(errorMessage);
                }
            }
        } catch (error) {
            const errorData = error?.response?.data;
            if (errorData?.errors?.email) {
                setErrors({ email: errorData.errors.email });
            }
        } finally {
            setLoader(false);
        }
    };

    return (
        <div className='sign-up-main login forgot-password-page'>
            <div className='sign-right'>
                <div
                    className='login-bg-image'
                    style={{
                        backgroundImage: `url(${window.getPublicUrl('/assets/images/login-bg.png')})`
                    }}
                >
                </div>
            </div>
            <div className='sign-left'>
                <div className="login-card">
                    <h2>Forgot Password</h2>
                    <h4>
                        {emailSent
                            ? 'Check your email for a link to reset your password.'
                            : 'Enter your email and we’ll send you a link to reset your password.'}
                    </h4>

                    {emailSent ? (
                        <div className="forgot-password-success">
                            <p>If you don&apos;t see the email, check your spam folder.</p>
                            <Link to="/login" className="login-signin-btn forgot-password-back-btn">
                                Back to Login
                            </Link>
                        </div>
                    ) : (
                        <form onSubmit={handleForgotPassword}>
                            <div className="login-form-group">
                                <label>Email</label>
                                <input
                                    type="email"
                                    placeholder="Ex-Johndow342@gmail.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === ' ') e.preventDefault();
                                    }}
                                    required
                                />
                                {errors.email && <div className="error">{errors.email}</div>}
                            </div>

                            <Button
                                variant="primary"
                                className="login-signin-btn"
                                type="submit"
                                disabled={loader}
                            >
                                {loader && (
                                    <span className="spinner-border spinner-border-sm me-2" role="status">
                                        <span className="visually-hidden">Loading</span>
                                    </span>
                                )}
                                Send Reset Link
                            </Button>
                        </form>
                    )}

                    {!emailSent && (
                        <div className="forgot-password-back">
                            <Link to="/login" className="back-to-login">
                                ← Back to Login
                            </Link>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;
